import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Button } from 'ui';
import { getApiErrorMessage } from 'utils/getApiErrorMessage';

import { useRejectPersonalDataDecision } from 'hooks/usePersonalDataChange';

import classes from './PersonalDataPages.module.scss';

export const PersonalDataRejectPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const reject = useRejectPersonalDataDecision();
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!token || started) return;
    setStarted(true);
    reject.mutate(token);
  }, [token, started, reject]);

  if (!token) {
    return (
      <section className={classes.wrapper}>
        <div className={classes.card}>
          <h1 className={classes.title}>Неверная ссылка</h1>
        </div>
      </section>
    );
  }

  return (
    <section className={classes.wrapper}>
      <div className={classes.card}>
        {reject.isPending && <h1 className={classes.title}>Обработка отказа...</h1>}
        {reject.isSuccess && (
          <>
            <h1 className={classes.title}>Заявка отклонена</h1>
            <p className={classes.text}>Изменения не будут применены.</p>
            <Button onClick={() => navigate('/login')}>Закрыть</Button>
          </>
        )}
        {reject.isError && (
          <>
            <h1 className={classes.title}>Ошибка</h1>
            <p className={`${classes.text} ${classes.error}`}>
              {getApiErrorMessage(reject.error, 'Ссылка недействительна')}
            </p>
          </>
        )}
      </div>
    </section>
  );
};
